import { render, staticRenderFns } from "./boards.vue?vue&type=template&id=f8b447ae&scoped=true"
import script from "./boards.vue?vue&type=script&lang=js"
export * from "./boards.vue?vue&type=script&lang=js"
import style0 from "./boards.vue?vue&type=style&index=0&id=f8b447ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b447ae",
  null
  
)

export default component.exports